import { yupResolver } from "@hookform/resolvers/yup";
import { Button, HStack, VStack } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";

import FormButton from "@/components/atoms/FormButton";
import SecureTextInput from "@/components/atoms/SecureTextInput";
import TermsButton from "@/components/atoms/TermsButton";
import TextInput from "@/components/atoms/TextInput";
import FormField from "@/components/molecules/FormField";

import { LoginFormData, schema } from "../schema";
import { LoginFormProps } from "../types";

type FormProps = LoginFormProps;

const Form = ({ isSubmiting, onSubmit, onRecoveryPass, onSingUp }: FormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: yupResolver(schema),
  });

  return (
    <VStack>
      <FormField
        control={control}
        name="email"
        label="E-mail"
        required
        error={errors.email}
        render={(value, onChange) => (
          <TextInput
            value={value}
            keyboardType="email-address"
            autoCapitalize="none"
            onChangeText={onChange}
            placeholder="E-mail"
          />
        )}
      />
      <FormField
        control={control}
        name="password"
        label="Senha"
        hint="Pelo menos 8 caracteres com letras e números"
        required
        error={errors.password}
        render={(value, onChange) => (
          <SecureTextInput
            value={value}
            autoCapitalize="none"
            onChangeText={onChange}
            placeholder="Senha"
          />
        )}
      />
      <FormButton isLoading={isSubmiting} mt="10" onPress={handleSubmit(onSubmit)}>
        Entrar
      </FormButton>
      <TermsButton />
      <HStack justifyContent="space-between">
        <Button variant="ghost" onPress={() => onSingUp()}>
          Cadastre-se
        </Button>
        <Button variant="ghost" onPress={() => onRecoveryPass()}>
          Esqueci minha senha
        </Button>
      </HStack>
    </VStack>
  );
};

export default Form;
